import axios, { AxiosResponse } from "axios";
import { PUBLIC_BRANDING } from "@/store/urls/public";

/**
 * Fetch per-tenant branding by company slug (public, pre-login).
 */
export const get_branding = async (slug: string): Promise<AxiosResponse> => {
  return await axios.get(PUBLIC_BRANDING, { params: { company: slug } });
};
